import {observer} from 'mobx-react';
import React from 'react';

import {useI18n} from '@udemy/i18n';

import {FullPriceSummaryCreditDetails} from '../full-price-summary-credit-details/full-price-summary-credit-details.react-component';
import {FullPriceSummaryCreditTotal} from '../full-price-summary-credit-total/full-price-summary-credit-total.react-component';
import styles from '../total-price/total-price.module.less';

interface List {
    listPriceAmount: number;
    purchasePriceAmount: number;
}

interface FullCreditTotalPriceProps {
    credit?: number;
    list: List;
    chargePrice: number;
    isSubtotalLabel?: boolean;
}

export const FullCreditTotalPrice: React.FC<FullCreditTotalPriceProps> = observer(
    ({credit = 0, list, chargePrice, isSubtotalLabel = false}) => {
        const {gettext} = useI18n();
        const creditsApplied =
            credit > list.purchasePriceAmount ? list.purchasePriceAmount : credit;

        return (
            <div>
                <div className={styles['full-credit-title']}>
                    <h2 className={'ud-heading-xl'}>{gettext('Summary')}</h2>
                </div>
                <FullPriceSummaryCreditDetails
                    couponDiscounts={list.listPriceAmount - list.purchasePriceAmount}
                    creditsApplied={creditsApplied}
                    listPriceAmount={list.listPriceAmount}
                />
                <FullPriceSummaryCreditTotal
                    remainingCredit={credit - creditsApplied}
                    chargePrice={chargePrice}
                    isSubtotalLabel={isSubtotalLabel}
                />
            </div>
        );
    },
);
